import React, { useEffect } from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { dashboardIcon } from "../../config/images";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import translations from "../../config/language";

const SideMenu = ({
  isSidebarOpen,
  selectedIndex,
  setSelectedIndex,
  isLogoutOpen,
  changePassword,
  galleryIsOpen
}) => {

  const { role, module_access } = useSelector((state) => state.userState);
  const admin = role == 3;

  const language = process.env.REACT_APP_LANGUAGE;

  const sidebarItems = [
    {
      icon: dashboardIcon.dashboardIcon,
      label: translations[language].dashboard,
      link: "/",
    },
    {
      icon: dashboardIcon.farmerIcon,
      label: translations[language].farmers,
      link: "/farmer",
      subPages: [
        { path: "/farmer/farmer-detail/:id", }
      ]
    },
    {
      icon: dashboardIcon.taskAssign,
      label: translations[language].taskAssignment,
      link: "/task-assignment",
      subPages: [
        { path: "/task-assignment/task-assignment-detail/:id", }
      ]
    },
    {
      icon: dashboardIcon.collectorListIcon,
      label: translations[language].dataCollectors,
      link: "/collectors-list",
      subPages: [
        { path: "/collectors-list/collector-detail/:id", }
      ]
    },
    {
      icon: dashboardIcon.ReportIcon,
      label: translations[language].reportSubmission,
      link: "/report-submission",
      subPages: [
        { path: "/report-submission/report-detail/:id", }
      ]
    },
    {
      icon: dashboardIcon.userManagementIcon,
      label: translations[language].userManagement,
      link: "/user-management",
      subPages: [
        { path: "/user-management/user-management-detail/:id", }
      ]
    },
    {
      icon: dashboardIcon.userManagementIcon,
      label: translations[language].roleManagement,
      link: "/role-management",
    },
    {
      icon: dashboardIcon.RegionIcon,
      label: translations[language].regionAndLocality,
      link: "/region-locality",
    },
    {
      icon: dashboardIcon.cropsIcon,
      label: translations[language].typeOfCrops,
      link: "/crops",
      subPages: [
        { path: "/crops/crops-data/:id", }
      ]
    },
    {
      icon: dashboardIcon.livestockIcon,
      label: translations[language].typeOfLivestock,
      link: "/livestock",
      subPages: [
        { path: "/livestock/livestock-data/:id", }
      ]
    },
    {
      icon: dashboardIcon.piscicultureIcon,
      label: translations[language].typeOfPisciculture,
      link: "/pisciculture",
      subPages: [
        { path: "/pisiciculture/pisiciculture-data/:id", }
      ]
    },
    {
      icon: dashboardIcon.machineryIcon,
      label: translations[language].typeOfMachinery,
      link: "/machinery",
      subPages: [
        { path: "/machinery/machinery-data/:id", }
      ]
    },
    {
      icon: dashboardIcon.certificationIcon,
      label: translations[language].certificationsAndTraining,
      link: "/certification",
    },
    {
      icon: dashboardIcon.trainingIcon,
      label: translations[language].trainingProgram,
      link: "/training-program",
      subPages: [
        { path: "/training-program/training-program-data/:id", }
      ]
    },
    {
      icon: dashboardIcon.whoSponsoredIcon,
      label: translations[language].whoSponsored,
      link: "/sponsored",
    },

  ];

  useEffect(() => {
    const currentPath = window.location.pathname;

    const matchingItem = sidebarItems.find(item => {
      if (currentPath === item.link) return true;
      if (item.subPages) {
        return item.subPages.some(subPage => {
          // Convert the pattern to regex to match exact paths
          const pattern = subPage.path.replace(':id', '[^/]+');
          const regex = new RegExp(`^${pattern}$`);
          return regex.test(currentPath);
        });
      }
      return false;
    });
    
    if (matchingItem) {
      setSelectedIndex(matchingItem.label);
    }
  }, [window.location.pathname]); // Add pathname as dependency

  return (
    <Box sx={{
      backgroundColor: "#f5f5f5",
      zIndex: (isLogoutOpen || changePassword || galleryIsOpen) ? 0 : 1000, // If either is true, zIndex is 0
    }}>
      <Box
        sx={{
          width: isSidebarOpen ? "250px" : "87px",
        }}
        className="sidemenu-box"
      >
        <Box>
          {sidebarItems
            // .filter((item) => (admin ? item.admin : true)) // Show only admin items if admin is true
            .filter((item) => {
              const modulePermission = module_access?.find(m => m.module_name.toLowerCase() === item.label.toLowerCase());
              return modulePermission ? !modulePermission.no_access : false;
            })
            .map((item, index) => (
              <Link key={item.label} to={item.link}>
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: isSidebarOpen ? "12px 16px" : "12px 22px",
                    gap: "10px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedIndex === item.label ? "#2E9559" : "transparent",
                    color: selectedIndex === item.label ? "#fff" : "black",
                    borderRadius: index === 0 ? "8px 8px 0px 0px" : "0px",
                  }}
                  onClick={() => setSelectedIndex(item.label)}
                >
                  <Tooltip
                    title={!isSidebarOpen ? item.label : ""}
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#31A05F",
                          color: "#fff",
                          fontSize: "14px",
                          borderRadius: "6px",
                          padding: "8px 12px",
                        },
                      },
                    }}
                  >
                    <Box sx={{ minWidth: "40px", textAlign: "center" }}>
                      <img
                        src={item.icon}
                        alt=""
                      // style={{ width: "30px", height: "30px" }}
                      />
                    </Box>
                  </Tooltip>
                  {isSidebarOpen && <Typography className="sidemenu-label">{item.label}</Typography>}
                </Box>
              </Link>
            ))}
        </Box>
      </Box>
    </Box>
  );
};
export default SideMenu;
